import { DropdownOption } from '@on-arte/ui';

import { ItemSaleEditStatus } from '@onArte/shared/enums';

export const itemSalesTypes: DropdownOption[] = [
  { name: ItemSaleEditStatus.Disabled.toString(), label: 'onarte.common.itemSalesTypes.disabled' },
  { name: ItemSaleEditStatus.BuyNow.toString(), label: 'onarte.common.itemSalesTypes.buyNow' },
  { name: ItemSaleEditStatus.PriceProposal.toString(), label: 'onarte.common.itemSalesTypes.priceProposal' },
];
